module.exports = "./img/c2b3ba84895bcaf73dbe3566eaa8f96f.jpg";